import ApiCrud from "./api-crud";

class MonedaService extends ApiCrud {
  resource = "monedas";
  primaryKey = "idmoneda";
}

export default new MonedaService();
